/*
 * @Descripttion: 
 * @version: 
 * @Author: ayf
 * @Date: 2021-07-02 11:58:36
 * @LastEditors: moxi-web-ayf
 * @LastEditTime: 2021-07-02 15:29:59
 */
import request from '@/utils/request'

// 登录
export function login (data) {
  return request({
    url: '/admin/login',
    method: 'post',
    data
  })
}

export function getInfo () {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout () {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList (params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin (data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin (id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus (id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin (id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin (id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole (data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}

// 日志
export function allLogs(params){
  return request({
    url:'/log/list',
    method:'post',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js